import { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import { withCompass } from "../../components/compass/withCompass";
const SearchGridHighlyRatedAdsCarouselPage = withCompass(
  () => import("../../pages/SearchGridHighlyRatedAdsCarouselPage")
);
const SearchGridPromotedBrandRowPage = withCompass(
  () => import("../../pages/SearchGridPromotedBrandRowPage")
);
const SearchGridPromotedCategoryBrandShopPage = withCompass(
  () => import("../../pages/SearchGridPromotedCategoryBrandShopPage")
);
const SearchGridRandomSpanningAdsPage = withCompass(
  () => import("../../pages/SearchGridRandomSpanningAdsPage")
);

export function EtienneLamoureuxRoutes() {
  return (
    <Switch>
      <Route
        path="/el/search-grid-highly-rated-ads-carousel"
        component={SearchGridHighlyRatedAdsCarouselPage}
      />
      <Route
        path="/el/search-grid-promoted-brand-row"
        component={SearchGridPromotedBrandRowPage}
      />
      <Route
        path="/el/search-grid-promoted-category-brand-shop"
        component={SearchGridPromotedCategoryBrandShopPage}
      />
      <Route
        path="/el/search-grid-random-spanning-ads"
        component={SearchGridRandomSpanningAdsPage}
      />
    </Switch>
  );
}

export const slug = "el";
